import React from 'react';
import './userAvathar.css';

export default () => {
    return(
        <div className="user_avathar">
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/userAvathar/userAvathar.js